<template>
  <v-row dense>
    <v-col cols="12">
      <v-card class="card-border">
        <v-card-text>
          <v-form ref="formFilter">
            <v-row dense>
              <v-col cols="12" sm="12" md="3">
                <SelectEmpresa @onChanged="empresa = $event" :multiple="false" />
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <SelectCampanha :empresas="empresa" @onChanged="campanha = $event" />
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <SelectColaborador
                  :multiple="true"
                  :empresas="empresa"
                  @onChanged="colaboradores = $event; changeColabIndex(true)"
                />
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <SelectPdfLayout :campanha="campanha" @onChanged="layout = $event" />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12">
      <v-card class="card-border">
        <v-card-text>
          <v-row justify="center">
            <v-col cols="12" sm="12" align="center">
              <span v-show="skeleton" style="font-weight: bold">Aguardando selecionar um layout...</span>
              <v-skeleton-loader
                class="mx-auto"
                :transition="'fade-transition'"
                type="card"
                :loading="skeleton"
              >
                <object
                  :data="pdfUrl"
                  type="application/pdf"
                  :width="embedSettings.width"
                  :height="embedSettings.height"
                  class="elevation-1"
                >
                  <embed
                    :src="pdfUrl"
                    type="application/pdf"
                    :width="embedSettings.width"
                    :height="embedSettings.height"
                  />
                </object>
              </v-skeleton-loader>
            </v-col>
            <v-col cols="12" sm="12" align="center">
              <div v-if="colaboradores.length > 0" class="text-center">
                <v-btn @click="changeColabIndex(false)" color="black" outlined fab x-small>
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <span class="mr-2 ml-2">{{ colaboradores[colabIndex].nome }}</span>
                <v-btn @click="changeColabIndex(true)" color="black" outlined fab x-small>
                  <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col v-show="!skeleton && !disableButtons" cols="12" align="center">
      <v-btn color="blue darken-2" outlined rounded small @click="salvar()">
        <v-icon left>mdi-image</v-icon>Salvar
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { PDFDocument, rgb, StandardFonts, degrees, error } from "pdf-lib";
import { Arquivos } from "@/services/materiais";
import Usuarios from "@/services/usuarios";

export default {
  name: "PdfLayout",

  components: {
    SelectEmpresa: () => import("@/components/select/SelectEmpresa"),
    SelectColaborador: () => import("@/components/select/SelectColaborador"),
    SelectCampanha: () => import("@/components/select/SelectCampanha"),
    SelectPdfLayout: () => import("@/components/select/SelectPdfLayout")
  },

  data() {
    return {
      empresa: null,
      colaboradores: [],
      campanha: null,
      layout: null,

      colabIndex: -1,

      pdfDoc: null,
      pdfUrl: "",
      pdfScale: 1,
      pageNum: 1,
      pageCount: 1,
      canvasRendering: false,

      embedSettings: {
        width: "75%",
        height: "100%"
      },

      skeleton: true,
      disableButtons: false
    };
  },

  methods: {
    async writePdf(userData = null) {
      if (!this.layout) return;

      try {
        const existingPdfBytes = await fetch(this.layout.url).then(res =>
          res.arrayBuffer()
        );

        this.pdfDoc = await PDFDocument.load(existingPdfBytes);
        this.pageCount = this.pdfDoc.getPageCount();
        this.pageNum = 1;

        const pages = this.pdfDoc.getPages();
        let fontName = this.layout.font.value.replace("-", "");
        const embedFont = await this.pdfDoc.embedFont(StandardFonts[fontName]);
        const { width, height } = pages[0].getSize();

        let nomeText = "";
        let telefoneText = "";

        if (this.colaboradores.length > 0 && userData) {
          //nomeText = this.colaboradores[this.colabIndex].apelido
          //telefoneText = this.colaboradores[this.colabIndex].telefone
          nomeText = userData.apelido;
          telefoneText = userData.telefone;
        } else {
          nomeText = this.layout.arrNome[0].text;
          telefoneText = this.layout.arrTelefone[0].text;
        }

        for (let i = 0; i < this.pageCount; i++) {
          if (this.layout.arrNome[i].show) {
            let color = this.$functions.convertHexToRgb(
              this.layout.arrNome[i].color
            );
            pages[i].drawText(nomeText.toUpperCase(), {
              x: this.layout.arrNome[i].x,
              y: this.layout.arrNome[i].y,
              size: parseInt(this.layout.arrNome[i].size),
              font: embedFont,
              color: rgb(color.r, color.g, color.b)
            });
          }

          if (this.layout.arrTelefone[i].show) {
            let color = this.$functions.convertHexToRgb(
              this.layout.arrTelefone[i].color
            );
            pages[i].drawText(telefoneText, {
              x: this.layout.arrTelefone[i].x,
              y: this.layout.arrTelefone[i].y,
              size: parseInt(this.layout.arrTelefone[i].size),
              font: embedFont,
              color: rgb(color.r, color.g, color.b)
            });
          }
        }

        const bytes = await this.pdfDoc.save();
        let url = this.$functions.convertUintArrayToUrl(bytes);

        this.embedSettings.height = height + 200;
        this.pdfUrl = url;
        this.skeleton = false;

        return Promise.resolve({
          url: url,
          bytes: bytes
        });
      } catch (error) {
        console.error(error);
        this.$toast.error(error);
        return Promise.reject(error);
      }
    },

    async changeColabIndex(increment = true) {
      if (this.colaboradores.length <= 0) return;

      this.colabIndex += increment ? 1 : -1;
      if (
        this.colabIndex > this.colaboradores.length - 1 ||
        this.colabIndex < 0
      )
        this.colabIndex = 0;

      let usuarioData = await new Usuarios().getUsuarioByCpf(
        this.colaboradores[this.colabIndex].cpf
      );
      if (!usuarioData) {
        let errors = `${
          this.colaboradores[this.colabIndex].nome
        } não possui usuário cadastrado. <br><br>`;
        this.$swal.warning(
          "Atenção",
          `<p style="text-align: left">${errors}</p>`
        );
        return;
      } else if (!usuarioData.apelido || !usuarioData.telefone) {
        let errors = `${
          this.colaboradores[this.colabIndex].nome
        } está com os dados do usuário incompleto. <br><br>`;
        this.$swal.warning(
          "Atenção",
          `<p style="text-align: left">${errors}</p>`
        );
        return;
      }

      this.writePdf(usuarioData);
    },

    async salvar() {
      if (!this.empresa) {
        this.$toast.warning("Selecione uma empresa");
        return;
      }
      if (this.colaboradores.length <= 0) {
        this.$toast.warning("Selecione os vendedores");
        return;
      }
      if (!this.campanha) {
        this.$toast.warning("Selecione uma campanha");
        return;
      }
      if (!this.layout) {
        this.$toast.warning("Selecione um layout");
        return;
      }

      this.colabIndex = 0;
      try {
        for (let indice in this.colaboradores) {
          this.colabIndex = indice;

          let usuarioData = await new Usuarios().getUsuarioByCpf(
            this.colaboradores[indice].cpf
          );

          if (!usuarioData) {
            this.$toast.error(
              `<p style="text-align: left">${this.colaboradores[indice].nome} não possui usuário cadastrado. <br><br></p>`
            );
          } else if (!usuarioData.apelido || !usuarioData.telefone) {
            this.$toast.error(
              `<p style="text-align: left">${
                this.colaboradores[this.colabIndex].nome
              } está com os dados do usuário incompleto. <br><br></p>`
            );
          } else {
            this.$loading.setLoading(
              true,
              `Gerando PDF do vendedor: ${this.colaboradores[indice].nome}`
            );
            let obj = await this.writePdf(usuarioData);
            await new Arquivos().createPdfByLayout(
              this.empresa,
              this.colaboradores[indice].cpf,
              this.campanha,
              this.layout.descricao,
              this.layout.id,
              obj.bytes
            );
          }
        }
      } catch (error) {
        console.error(error);
        this.$toast.error(error);
      } finally {
        this.$swal.success("Salvo com sucesso");
        this.$loading.setLoading(false);
      }
    }
  },

  watch: {
    layout: {
      handler() {
        this.writePdf();
      },
      deep: true
    }
  }
};
</script>
